/**
 * Knowledge-base document constants, shared by oem and the portal's document
 * preview. Moved from oem's `~/constants/knowledgebase`, which re-exports them.
 */

export const IMAGE_FILE_TYPES = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "mpo",
  "webp",
  "avif",
  "heif",
];

export const DEFAULT_DOCUMENT_LANGUAGE_OPTION = {
  label: "Default Document Language",
  value: "content",
};

export const DOC_FILE_TYPES = ["pdf", "docx", "pptx", "xlsx"];

export const TRANSLATION_STATUS = {
  PENDING: 9000,
  TRANSLATING: 9001,
  TRANSLATED: 9002,
  FAILED: 9003,
};
